import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.13 11.07L17.5 12.52L11.75 18L6 12.52L7.37 11.07L11.75 15.24L16.13 11.07ZM17.5 7.45L16.13 6L11.75 10.17L7.37 6L6 7.45L11.75 12.93L17.5 7.45Z" fill={ fill || 'currentColor' } />
    </svg>
);
